export default ({ formComponents }) => {
  const { input, select } = formComponents;
  return {
    caret: {
      ...select.caret
    },

    root: {
      '& svg': {
        display: select.caretIcon,
        fill: ({ dark }) => (dark ? select.darkIconFill : select.iconFill),
        pointerEvents: 'none',
        position: 'absolute',
        right: select.caretRight,
        top: select.caretTop
      },

      position: 'relative'
    },
    select: {
      '& option': {
        backgroundColor: ({ dark }) => (
          dark
            ? select.darkOptionBackground
            : select.optionBackground),
        color: ({ dark }) => (dark ? select.darkOptionColor : select.optionColor)
      },
      '&::-ms-expand': {
        // necessary evil for IE 11, appearance should work in edge
        display: 'none'
      },
      '&:disabled': {
        backgroundColor: '#EDEDED',
        cursor: 'not-allowed',
        opacity: 1
      },
      '&:focus': {
        outlineColor: ({ dark }) => (dark ? select.darkFocusColor : select.focusColor)
      },
      appearance: 'none',
      background: input.backgroundColor,
      border: input.border,
      borderColor: ({ dark, error, warning }) => !!error && (dark ? (
        warning ? formComponents.dark.warning.borderColor : formComponents.dark.error.borderColor
      ) : (
        warning ? formComponents.warning.borderColor : formComponents.error.borderColor
      )),
      borderRadius: input.borderRadius,
      color: ({ dark }) => (dark ? input.darkColor : input.color),
      fontFamily: input.fontFamily,
      fontSize: input.fontSize,
      fontWeight: input.fontWeight,

      lineHeight: 1,

      padding: select.padding,

      width: '100%'
    }
  };
};
